import { LogoMark } from './ui/Logo';
import { AUTH_LOADING_SHELL_CLASS, AUTH_LOADING_SHELL_STYLE } from './auth/AuthLoadingIndicator';
import { resolveEscapeDestination } from '../lib/clerkEscapeLink';

/**
 * Shown when the dashboard bundle runs on an origin its Clerk production key
 * cannot satisfy -- the team-review proxy renders it on the Railway proxy host.
 * Sign-in can never load there, so ProtectedRoute renders this instead of the
 * loading screen. It reports nothing to analytics (the whole point is to stop
 * minting a fake auth_load_failed) and offers no Retry, because a reload on the
 * same origin would land on the same wall.
 *
 * It states plainly that this is a preview and points the reviewer at a page
 * that needs no sign-in: the page they came from when we can trust it (the
 * allow-listed escape from lib/clerkEscapeLink), or the marketing home.
 */
export function ClerkOriginBlockedScreen() {
  const escape = resolveEscapeDestination(
    typeof document === 'undefined' ? '' : document.referrer,
  );

  return (
    <main className={AUTH_LOADING_SHELL_CLASS} style={AUTH_LOADING_SHELL_STYLE}>
      <section className="card-sm w-full max-w-sm text-center">
        <div className="flex justify-center">
          <LogoMark className="w-8 h-8" />
        </div>
        <h1 className="mt-4 text-base font-semibold text-gray-900">
          Sign-in is not available on this preview
        </h1>
        <p className="mt-2 text-sm leading-6 text-gray-600">
          You are viewing a preview of the OverlayQA dashboard. Open OverlayQA
          directly to sign in.
        </p>
        <a className="btn-primary mt-5 inline-flex" href={escape.href}>
          <span className="text-cap-trim">{escape.fromReferrer ? 'Go back to the page you came from' : 'Go to OverlayQA'}</span>
        </a>
      </section>
    </main>
  );
}
